import{storageSet as o}from"../../utils/storage";import{PRAXIS_REDIRECT_AFTERAUTH as t}from"../../constants";export const login=({redirect:i,loginUrl:r})=>{// save current route
if(i){o(t,i)}// redirect to OAuth login page
window.location.replace(r)};